import Tooltip from '@/common/helios/Tooltip';
import { useIsMobile } from '~/context/common/DeviceContext';
import {
  BlueBox,
  Bold,
  InnerWrapper,
  List,
  ListWrapper,
  Section,
  SubTitle,
  Title
} from './EvEligibility.styles';
import ExternalSiteLink from '../ExternalSiteLink';

export default function AreYouQualified() {
  const isMobile = useIsMobile();

  return (
    <Section>
      <Title>Are You Qualified for the EV Tax Credit?</Title>
      <BlueBox>
        <InnerWrapper>
          <ListWrapper>
            <SubTitle>
              If your modified adjusted gross income (MAGI) exceeds the
              following amounts, you won’t qualify for the used EV tax credit:
            </SubTitle>
            <List>
              <li>$112,500 for heads of household</li>
              <li>
                $150,000 for joint filers <Bold>or</Bold> spouses
              </li>
              <li>$75,000 for all other filers</li>
            </List>
            <div>
              <Tooltip
                title="Modified Adjusted Gross Income (MAGI)"
                content={
                  <div className="text-left text-text-inverse t-body-sm">
                    Your AGI is gross income minus adjustments to income. Your
                    MAGI for purposes of the EV Credit is AGI plus Foreign
                    Earned Income, plus any amount excluded from gross income
                    because it was received from sources in Puerto Rico or
                    American Samoa. Additional details on MAGI for the EV Credit{' '}
                    <ExternalSiteLink
                      section="Are You Qualified"
                      style="current"
                      url="https://www.fueleconomy.gov/feg/tax2023.shtml#requirements"
                    >
                      can be found here
                    </ExternalSiteLink>
                    . You can use your MAGI from the year before your vehicle
                    purchase or the year of your vehicle purchase to determine
                    eligibility for the tax credit. For example, if your MAGI
                    was below the qualifying threshold for your tax filer status
                    in 2022 but not 2023, you could still qualify for a used EV
                    tax credit in 2023.
                  </div>
                }
                direction={isMobile ? 'top' : 'top-start'}
                display={{
                  width: 327,
                  contentOffsetX: -2,
                  arrowOffsetX: 25
                }}
              >
                <p className="text-text-strong t-link-md">
                  Learn more about MAGI
                </p>
              </Tooltip>
            </div>
          </ListWrapper>

          <ListWrapper>
            <SubTitle>
              In addition to meeting the MAGI requirements, you must:
            </SubTitle>
            <List>
              <li>
                Buy the car for personal use, <Bold>not</Bold> for resale
              </li>
              <li>
                <Bold>Not</Bold> be a dependent on someone else’s tax return
              </li>
              <li>
                <Bold>Not</Bold> have claimed another used EV tax credit within
                the last three years
              </li>
              <li>
                <Bold>Not</Bold> be the original owner of the vehicle you
                purchase.
              </li>
            </List>
          </ListWrapper>
        </InnerWrapper>
        <div className="t-body-m mt-4xl text-text-strong">
          Buyers who wish to take advantage of the federal used EV tax credit
          will need to attest that they meet the qualifications and income
          limits above.
        </div>
      </BlueBox>
    </Section>
  );
}
